// Auto-generated Alpha7 real image manifest
export const IMG = {
  "construction": [
    "/images/construction/construction-01.jpg",
    "/images/construction/construction-02.jpg",
    "/images/construction/construction-03.jpg",
    "/images/construction/construction-04.jpg",
    "/images/construction/construction-05.jpg",
    "/images/construction/construction-06.jpg",
    "/images/construction/construction-07.jpg",
    "/images/construction/construction-08.jpg",
    "/images/construction/construction-09.jpg",
    "/images/construction/construction-10.jpg",
    "/images/construction/construction-12.jpg",
    "/images/construction/construction-13.jpg",
    "/images/construction/construction-14.jpg"
  ],
  "electrical": [
    "/images/electrical/electrical-01.jpg",
    "/images/electrical/electrical-02.jpg",
    "/images/electrical/electrical-03.jpg",
    "/images/electrical/electrical-04.jpg",
    "/images/electrical/electrical-05.jpg",
    "/images/electrical/electrical-06.jpg",
    "/images/electrical/electrical-07.jpg",
    "/images/electrical/electrical-08.jpg",
    "/images/electrical/electrical-09.jpg",
    "/images/electrical/electrical-10.jpg",
    "/images/electrical/electrical-11.jpg",
    "/images/electrical/electrical-12.jpg",
    "/images/electrical/electrical-13.jpg"
  ],
  "industrial": [
    "/images/industrial/industrial-01.jpg",
    "/images/industrial/industrial-02.jpg",
    "/images/industrial/industrial-03.jpg",
    "/images/industrial/industrial-04.jpg",
    "/images/industrial/industrial-05.jpg",
    "/images/industrial/industrial-06.jpg",
    "/images/industrial/industrial-07.jpg",
    "/images/industrial/industrial-08.jpg",
    "/images/industrial/industrial-09.jpg",
    "/images/industrial/industrial-10.jpg",
    "/images/industrial/industrial-11.jpg",
    "/images/industrial/industrial-12.jpg",
    "/images/industrial/industrial-13.jpg"
  ],
  "workforce": [
    "/images/workforce/workforce-01.jpg",
    "/images/workforce/workforce-02.jpg",
    "/images/workforce/workforce-03.jpg",
    "/images/workforce/workforce-04.jpg",
    "/images/workforce/workforce-05.jpg",
    "/images/workforce/workforce-06.jpg",
    "/images/workforce/workforce-07.jpg",
    "/images/workforce/workforce-08.jpg",
    "/images/workforce/workforce-09.jpg",
    "/images/workforce/workforce-10.jpg",
    "/images/workforce/workforce-11.jpg",
    "/images/workforce/workforce-12.jpg"
  ],
  "agriculture": [
    "/images/agriculture/agriculture-01.jpg",
    "/images/agriculture/agriculture-02.jpg",
    "/images/agriculture/agriculture-04.jpg",
    "/images/agriculture/agriculture-05.jpg",
    "/images/agriculture/agriculture-06.jpg",
    "/images/agriculture/agriculture-07.jpg",
    "/images/agriculture/agriculture-08.jpg",
    "/images/agriculture/agriculture-09.jpg",
    "/images/agriculture/agriculture-10.jpg",
    "/images/agriculture/agriculture-11.jpg",
    "/images/agriculture/agriculture-12.jpg",
    "/images/agriculture/agriculture-13.jpg"
  ]
};
